import {atom} from "recoil";
import {persistAtomEffect} from "../effects/persistAtom";
export const walletModalLayoutState = atom({
  key: 'WalletModalLayoutState',
  default: 'row',
  effects: [
    persistAtomEffect
  ]
});
